import { ThemeOptions } from '@mui/material';

const spacing: NonNullable<ThemeOptions['spacing']> = (factor: number): string => `${0.5 * factor}rem`;

export default spacing;
